import { render, staticRenderFns } from "./DetailHistoryIcon.vue?vue&type=template&id=f47bd720"
import script from "./DetailHistoryIcon.vue?vue&type=script&lang=js"
export * from "./DetailHistoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports